import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetInstallationsEcrDataReqData } from "./GetInstallationsEcrDataReqData";
import { GetInstallationsEcrDataResData } from "./GetInstallationsEcrDataResData";

const ENDPOINT = "/fitness_statistics/installations_ecr_data";

export class GetInstallationsEcrDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: GetInstallationsEcrDataReqData = null;

    constructor(params: GetInstallationsEcrDataReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetInstallationsEcrDataResData> {
        var res = await this.executeCommand(this.params);
        return new GetInstallationsEcrDataResData(res);
    }
}
